import PropTypes from "prop-types"
import React, { useEffect } from "react"
import { Route, Switch, useHistory } from "react-router"
import styled from "styled-components"

import Layout from "../../../_shared/components/Layout"
import AuthPage from "../AuthPage"
import Booking from "./Booking"
import BookingRedirect from "./BookingRedirect"
import EditBooking from "./EditBooking"
import EditSuccess from "./EditSuccess"
import EventDetail from "./EventDetail"
import Events from "./Events"
import Redirect from "./Events/redirect"

// ----------------------------------------------------------------------------

function LoggedApp(props) {
    // -------------------------------------
    // Props destructuring
    // -------------------------------------

    const { url } = props.match

    // -------------------------------------
    // Hooks (e.g. useState, useMemo ...)
    // -------------------------------------

    const history = useHistory()

    // -------------------------------------
    // Effects
    // -------------------------------------

    useEffect(() => {
        if (url === "/events") history.push("/")
        //eslint-disable-next-line
    }, [url])

    // -------------------------------------
    // Component functions
    // -------------------------------------

    // -------------------------------------
    // Component local variables
    // -------------------------------------

    return (
        <Layout>
            <Switch>
                <Route exact path="/events" component={Redirect} />
                <Route path="/events/:id" component={EventDetail}></Route>
                <Route
                    path={`/provider-redirect/:id`}
                    component={BookingRedirect}
                />
                <Route exact path="/booking" component={Booking}></Route>
                <Route
                    exact
                    path="/booking/edit"
                    component={EditSuccess}
                ></Route>
                <Route
                    path="/bookings/:booking"
                    component={EditBooking}
                ></Route>
                <Route path="/login" component={AuthPage} />
                <Route path={`${props.match.url}`} component={Events}></Route>
            </Switch>
        </Layout>
    )
}

// ----------------------------------------------------------------------------
// Component PropTypes and default props
// ----------------------------------------------------------------------------

LoggedApp.propTypes = {
    className: PropTypes.string.isRequired,
    match: PropTypes.object,
}

LoggedApp.defaultProps = {}

// ----------------------------------------------------------------------------

const StyledLoggedApp = styled(LoggedApp)`
    & {
    }
`
// ----------------------------------------------------------------------------

export default StyledLoggedApp
